/**
 * OrientationGuide - デバイス回転誘導コンポーネント
 */

interface OrientationGuideProps {
  onContinue: () => void
  onCancel: () => void
  onIgnore: () => void
}

export function OrientationGuide({ onContinue, onCancel, onIgnore }: OrientationGuideProps) {
  return (
    <div className="h-full min-h-full bg-gray-900 text-white flex flex-col items-center justify-center px-6 py-4 overflow-auto"
      style={{ height: '100dvh' }}>
      {/* アニメーション付きアイコン */}
      <div className="mb-4 lg:mb-8">
        <div className="relative w-24 h-24 lg:w-32 lg:h-32 mx-auto">
          {/* 縦向きのデバイス */}
          <div className="absolute inset-0 flex items-center justify-center animate-pulse">
            <div className="w-16 h-24 border-2 border-gray-600 rounded-lg flex items-center justify-center">
              <span className="text-2xl">📱</span>
            </div>
          </div>
          
          {/* 矢印 */}
          <div className="absolute inset-0 flex items-center justify-center">
            <svg 
              className="w-full h-full animate-spin-slow" 
              viewBox="0 0 100 100"
              style={{ animation: 'rotate 2s ease-in-out infinite' }}
            >
              <path
                d="M 50 20 Q 70 35, 70 50 T 50 80"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
                className="text-blue-400"
              />
              <polygon
                points="45,80 55,80 50,90"
                fill="currentColor"
                className="text-blue-400"
              />
            </svg>
          </div>
        </div>

        {/* 横向きのデバイス（到達点） */}
        <div className="mt-4 flex justify-center">
          <div className="w-24 h-16 border-2 border-blue-400 rounded-lg flex items-center justify-center bg-blue-400/10">
            <span className="text-2xl">📱</span>
          </div>
        </div>
      </div>

      {/* テキスト */}
      <h2 className="text-2xl font-bold mb-3">デバイスを横向きに</h2>
      <p className="text-gray-400 text-center mb-2">
        パノラマ撮影では横向きがおすすめです
      </p>
      <p className="text-sm text-gray-500 text-center mb-8">
        より広い画角で効率的に撮影できます
      </p>

      {/* ボタン */}
      <div className="w-full max-w-sm space-y-3">
        <button
          onClick={onContinue}
          className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium transition-colors"
        >
          横向きにしました
        </button>
        
        <button
          onClick={onIgnore}
          className="w-full py-3 px-6 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
        >
          縦向きで続ける
        </button>
        
        <button
          onClick={onCancel}
          className="w-full py-2 text-gray-400 hover:text-white transition-colors"
        >
          キャンセル
        </button>
      </div>

      <style>{`
        @keyframes rotate {
          0% {
            transform: rotate(0deg);
          }
          50% {
            transform: rotate(90deg);
          }
          100% {
            transform: rotate(90deg);
          }
        }
      `}</style>
    </div>
  )
}